import React from 'react';

const About = () => {
  const features = [
    '✅ 10+ Years Experience',
    '✅ 500+ Projects Delivered',
    '✅ Certified Professionals',
    '✅ 24/7 Support Available',
    '✅ Government Approved',
    '✅ Pan India Presence',
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-image">
          <div className="about-img-wrapper">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=500&fit=crop"
              alt="Our Team"
            />
            <div className="about-img-overlay">
              <h4>10+</h4>
              <p>Years of Excellence</p>
            </div>
          </div>
        </div>

        <div className="about-content">
          <span className="section-badge">About Us</span>
          <h2>Your Trusted Multi-Service Business Partner</h2>
          <p>
            We are a dynamic multi-service company committed to delivering
            exceptional solutions across diverse business domains. From
            organizing world-class events to developing cutting-edge software,
            we bring expertise, creativity, and professionalism to every
            project we undertake.
          </p>
          <p>
            Our team of seasoned professionals ensures that every service we
            provide meets the highest standards of quality and exceeds client
            expectations.
          </p>

          <div className="about-features">
            {features.map((feature, idx) => (
              <div className="about-feature" key={idx}>
                <span>{feature}</span>
              </div>
            ))}
          </div>

          <a href="#contact" className="btn-primary">
            Get Started Today →
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;